import styled from "@emotion/styled";

interface BodyContainerProps {
  width: string;
}

const BodyContainer = styled.div<BodyContainerProps>`
  width: ${(props) => props.width};
  margin: auto;
`;

export default BodyContainer;
